import { AUDIT_SOCKET, SOCKET_EVENTS } from "@markedesk/core-contracts";

/**
 * Assina os registros novos de auditoria enquanto a tela está aberta.
 *
 * Entra na sala (o backend só deixa admin/super) e entra DE NOVO a cada
 * reconexão — o socket reconectado volta sem salas, e sem isto a tela ficaria
 * surda até ser reaberta. Devolve a função que desfaz tudo (sai da sala e tira
 * os handlers), para o cleanup do useEffect.
 */
export const subscribeAuditRecorded = (socket, onRecorded) => {
  if (!socket) return () => {};

  const join = () => socket.emit(AUDIT_SOCKET.JOIN);
  const handle = payload => onRecorded(payload?.record);

  join();
  socket.on("connect", join);
  socket.on(SOCKET_EVENTS.AUDIT.RECORDED, handle);

  return () => {
    socket.emit(AUDIT_SOCKET.LEAVE);
    socket.off("connect", join);
    socket.off(SOCKET_EVENTS.AUDIT.RECORDED, handle);
  };
};
